export default __webpack_public_path__ + "static/media/walletBackground1.4c5125a9.svg";